import { render, staticRenderFns } from "./TeacherAbsentThanks.vue?vue&type=template&id=27256354"
import script from "./TeacherAbsentThanks.vue?vue&type=script&lang=js"
export * from "./TeacherAbsentThanks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports